export default {
  meta: {
    title: '利用率分析'
  }
};
